import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  FormLabel,
  Row,
} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormFeedback } from 'reactstrap';
import classnames from 'classnames';
import { appName, currentYear } from '../common/helpers';
import PageMetaData from '../common/components/pageMetaData/PageMetaData';
import HorizontalLogo from '../common/components/logo/HorizontalLogo';
import { forgotPassword } from '../auth/AuthActions';
import RouterPaths from '../constants/RouterPaths';
import ForgotPasswordSchema from '../auth/forgotpassword/ForgotPasswordForm.schema';

function ForgotPasswordLayout() {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleRecoverPassword = () => {
    setErrors({});
    ForgotPasswordSchema.validate(
      {
        email,
      },
      { abortEarly: false },
    )
      .then(() => {
        dispatch(
          forgotPassword({ email }, () => {
            setEmail('');
          }),
        );
      })
      .catch((validation) => {
        const err = {};
        validation.inner.forEach((e) => {
          err[e.path] = e.message;
        });

        setErrors({
          ...err,
        });
      });
  };

  return (
    <div className="auth-box overflow-hidden align-items-center d-flex">
      <PageMetaData title="Forgot Password" />
      <Container>
        <Row className="justify-content-center">
          <Col xxl={4} md={6} sm={8}>
            <div className="auth-brand text-center mb-4">
              <HorizontalLogo />
              <h4 className="fw-bold mt-3">Forgot Password ?</h4>
              <p className="text-muted w-lg-75 mx-auto">
                Enter your email address and we&apos;ll send you a link to reset your password.
              </p>
              <p className="fw-bold w-lg-75 mx-auto">Only for superadmins</p>
            </div>

            <Card className="p-4 rounded-4">
              <Form>
                <div className="mb-3 form-group">
                  <FormLabel>
                    Email address <span className="text-danger">*</span>
                  </FormLabel>
                  <FormControl
                    type="email"
                    placeholder="you@example.com"
                    className={classnames('form-control', errors.email && 'is-invalid')}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors?.email && <FormFeedback>{errors.email}</FormFeedback>}
                </div>

                <div className="d-grid">
                  <Button
                    className="rounded-pill btn-primary fw-semibold py-2"
                    onClick={() => handleRecoverPassword(email, forgotPassword)}
                  >
                    Send Email
                  </Button>
                </div>
              </Form>

              <p className="text-muted text-center mt-4 mb-0">
                Return to{' '}
                <Link
                  to={RouterPaths.LOGIN}
                  className="text-decoration-underline text-primary link-offset-3 fw-semibold"
                >
                  Sign in
                </Link>
              </p>
            </Card>

            <p className="text-center text-muted mt-4 mb-0">
              © {currentYear} <span className="fw-semibold">{appName}</span>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ForgotPasswordLayout;
